import IconAlert from '@/components/common/IconAlert';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TRACKER_UPGRADE_PATH = '/prorogate-or-upgrade/';

interface TrackerKeywordsInactiveAlertProps {
  className?: string;
  showButton?: boolean;
}

const TrackerKeywordsInactiveAlert = ({
  className,
  showButton = true
}: TrackerKeywordsInactiveAlertProps) => (
  <IconAlert
    variant="warning"
    customIcon="lock"
    iconClasses="fs-0"
    className={className}
  >
    <div className="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-start align-items-md-center">
      <span className="text-justify pe-md-3">
        با توجه به طرح فعلی، این بخش برای شما فعال نیست. برای فعال‌سازی
        می‌توانید{' '}
        <Link to={TRACKER_UPGRADE_PATH}>افزونهٔ ردیاب کلمات</Link> را
        خریداری کنید.
      </span>
      {showButton && (
        <Link
          to={TRACKER_UPGRADE_PATH}
          className="text-decoration-none flex-shrink-0"
        >
          <Button variant="falcon-primary" size="sm" className="fs--1 py-1 px-2">
            خرید افزونه ردیاب
          </Button>
        </Link>
      )}
    </div>
  </IconAlert>
);

export default TrackerKeywordsInactiveAlert;
